/**
 * What this browser calls itself: the device name a join stores (`POST /api/auth/invite`) and the
 * platform label. Browser-only since the Capacitor shell was removed (W15/B11) — the platform is
 * read from the user agent, never guessed from a bridge that is no longer there.
 */
export function platformName(): string {
  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) return 'ios'
  if (/Android/.test(navigator.userAgent)) return 'android'
  return 'web'
}

/** Human label stored as the device name on `POST /api/auth/invite`. */
export function defaultDeviceName(): string {
  const ua = navigator.userAgent
  const browser = /Edg\//.test(ua)
    ? 'Edge'
    : /OPR\//.test(ua)
      ? 'Opera'
      : /Firefox\//.test(ua)
        ? 'Firefox'
        : /CriOS|Chrome\//.test(ua)
          ? 'Chrome'
          : /Safari\//.test(ua)
            ? 'Safari'
            : 'Browser'
  const platform = platformName()
  const label = platform === 'ios' ? 'iPhone' : platform === 'android' ? 'Android' : platform === 'web' ? 'Web' : platform
  return `${browser} on ${label}`
}
